export default __webpack_public_path__ + "static/media/icon_ellipsis_invalid.ae0c7390.svg";